module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gwc-box"
  }, [(!_vm.isDetail) ? _c('div', {
    staticClass: "gwc-box-container"
  }, [_c('div', {
    staticClass: "gwc-box-top"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.quanbushangpin')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/image/tanchuang_x@2x.png"),
      "alt": "关闭"
    },
    on: {
      "click": _vm.handleClose
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gwc-box-list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      class: index == _vm.listIndex ? 'gwc-box-list-item' : 'gwc-box-list-item1'
    }, [_c('div', {
      staticClass: "gwc-box-list-item-img"
    }, [_c('img', {
      staticClass: "gwc-box-list-item-img-img",
      attrs: {
        "src": item.masterImg[0],
        "alt": ""
      },
      on: {
        "error": _vm.handleImgError
      }
    }), _vm._v(" "), (item.inventory == 0) ? _c('div', {
      staticClass: "yiqiangguang"
    }, [_vm._v("- " + _vm._s(_vm.$t('all.yiqiangguang')) + " -")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "gwc-box-list-item-content"
    }, [_c('div', {
      staticClass: "gwc-box-list-item-content-name"
    }, [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('div', {
      staticClass: "gwc-box-list-item-content-kucun"
    }, [_vm._v("剩余库存：" + _vm._s(item.inventory))]), _vm._v(" "), _c('div', {
      staticClass: "gwc-box-list-item-content-price"
    }, [_c('div', {
      staticClass: "gwc-box-list-item-content-price-left"
    }, [_c('span', {
      staticClass: "gwc-box-list-item-content-price-left-span"
    }, [_vm._v("USDN")]), _vm._v(" "), _c('span', {
      staticClass: "gwc-box-list-item-content-price-left-span1"
    }, [_vm._v(_vm._s(item.price))])]), _vm._v(" "), _c('div', {
      staticClass: "gwc-box-list-item-content-price-btn",
      on: {
        "click": function($event) {
          return _vm.handleDetail(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.jiagou')))])])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isDetail) ? _c('div', {
    staticClass: "gwc-box-container"
  }, [_c('div', {
    staticClass: "gwc-box-top"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.shangpinxiangqing')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/image/tanchuang_x@2x.png"),
      "alt": "关闭"
    },
    on: {
      "click": _vm.handleClose
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gwc-box-xq"
  }, [_c('div', {
    staticClass: "gwc-box-xq-lbt"
  }, [_c('carousel', {
    attrs: {
      "images": _vm.data.masterImg,
      "interval": 3000
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gwc-box-xq-name"
  }, [_vm._v(_vm._s(_vm.data.goodsName))]), _vm._v(" "), _c('div', {
    staticClass: "gwc-box-xq-price"
  }, [_c('div', {
    staticClass: "gwc-box-xq-price-left"
  }, [_c('span', {
    staticClass: "gwc-box-xq-price-span"
  }, [_vm._v("USDN")]), _vm._v(" "), _c('span', {
    staticClass: "gwc-box-xq-price-span-span1"
  }, [_vm._v(_vm._s(_vm.data.price))])]), _vm._v(" "), _c('div', {
    staticClass: "gwc-box-xq-price-right"
  }, [_vm._v("剩余库存：" + _vm._s(_vm.data.inventory))])]), _vm._v(" "), _c('div', {
    staticClass: "gwc-box-xq-title"
  }, [_c('span', {
    staticClass: "gwc-box-xq-title-span"
  }), _vm._v(" "), _c('span', {
    staticClass: "gwc-box-xq-title-span1"
  }, [_vm._v(_vm._s(_vm.$t('all.shangpinxiangqing')))]), _vm._v(" "), _c('span', {
    staticClass: "gwc-box-xq-title-span"
  })]), _vm._v(" "), _c('div', {
    staticClass: "gwc-box-xq-img"
  }, _vm._l((_vm.data.masterImg), function(item, index) {
    return _c('img', {
      key: index,
      attrs: {
        "src": item,
        "alt": ""
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "gwc-box-xq-btn"
  }, [_c('div', {
    staticClass: "gwc-box-xq-btn-btn",
    on: {
      "click": function($event) {
        _vm.show = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.lijijiagou')))])]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "gwc-mask",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "gwc-mask-model"
  }, [_c('div', {
    staticClass: "gwc-mask-model-top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/tanchuang_x@2x.png"),
      "alt": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gwc-mask-model-goods"
  }, [_c('img', {
    staticClass: "gwc-mask-model-goods-img",
    attrs: {
      "src": _vm.data.masterImg[0],
      "alt": ""
    },
    on: {
      "error": _vm.handleImgError
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gwc-mask-model-goods-content"
  }, [_c('div', {
    staticClass: "gwc-mask-model-goods-content-price"
  }, [_c('span', {
    staticClass: "gwc-mask-model-goods-content-price-span"
  }, [_vm._v("USDN")]), _vm._v(" "), _c('span', {
    staticClass: "gwc-mask-model-goods-content-price-span1"
  }, [_vm._v(_vm._s(_vm.data.specificationList[_vm.ggIndex].price * _vm.num))])]), _vm._v(" "), _c('div', {
    staticClass: "gwc-mask-model-goods-content-kucun"
  }, [_vm._v("剩余库存：" + _vm._s(_vm.data.inventory))]), _vm._v(" "), _c('div', {
    staticClass: "gwc-mask-model-goods-content-num"
  }, [_c('div', {
    staticClass: "gwc-mask-model-goods-content-num-left"
  }, [_vm._v(_vm._s(_vm.$t('all.yixuan')) + "：" + _vm._s(_vm.data.specificationList[_vm.ggIndex].name))]), _vm._v(" "), _c('div', {
    staticClass: "gwc-mask-model-goods-content-num-right"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/shuliang_-@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleNum(-1)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.num))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/image/shuliang_+@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleNum(1)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "gwc-mask-model-gg"
  }, [_c('div', {
    staticClass: "gwc-mask-model-gg-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xuanzeguige')))]), _vm._v(" "), _c('div', {
    staticClass: "gwc-mask-model-gg-list"
  }, _vm._l((_vm.data.specificationList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.ggIndex === index ? 'gwc-mask-model-gg-list-item' : 'gwc-mask-model-gg-list-item1',
      on: {
        "click": function($event) {
          return _vm.handleGg(index)
        }
      }
    }, [_c('div', {
      staticClass: "gwc-mask-model-gg-list-item-left"
    }, [_c('img', {
      attrs: {
        "src": _vm.data.masterImg[0],
        "alt": ""
      },
      on: {
        "error": _vm.handleImgError
      }
    }), _vm._v(" "), _c('span', {
      class: _vm.ggIndex === index ? 'gwc-mask-model-gg-list-item-left-span' : 'gwc-mask-model-gg-list-item-left-span1'
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      class: _vm.ggIndex === index ? 'gwc-mask-model-gg-list-item-left-span2' : 'gwc-mask-model-gg-list-item-left-span3'
    }, [_vm._v("库存：" + _vm._s(item.inventory))])]), _vm._v(" "), _c('div', {
      staticClass: "gwc-mask-model-gg-list-item-right"
    }, [_c('span', {
      class: index === _vm.ggIndex ? 'gwc-mask-model-gg-list-item-right-span' : 'gwc-mask-model-gg-list-item-right-span_1'
    }, [_vm._v("USDN")]), _vm._v(" "), _c('span', {
      class: index === _vm.ggIndex ? 'gwc-mask-model-gg-list-item-right-span1' : 'gwc-mask-model-gg-list-item-right-span1_1'
    }, [_vm._v(_vm._s(item.price))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "gwc-box-xq-btn"
  }, [_c('div', {
    staticClass: "gwc-box-xq-btn-btn",
    on: {
      "click": _vm.submitOrder
    }
  }, [_vm._v(_vm._s(_vm.$t('all.lijijiagou')))])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1301cfbe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/gouwuche/gouwuche.vue
// module id = 955
// module chunks = 1